import { render, staticRenderFns } from "./carousel-ribbon.vue?vue&type=template&id=335855e4"
import script from "./carousel-ribbon.vue?vue&type=script&lang=js"
export * from "./carousel-ribbon.vue?vue&type=script&lang=js"
import style0 from "./carousel-ribbon.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports